import { AddPatrons } from "@/features/AddPatrons";
import { Patron } from "@/features/AddPatrons/types";
import { VStack } from "@whoosh/design-system/src/components/primitive";

type Props = {
  mode: "add" | "replace";
  search: string;
  setSearch: (value: string) => void;
  selectedIds: string[];
  isAtCapacity: boolean;
  onToggleAttendee: (patron: Patron, checked: boolean) => void;
};

export const AttendeeAddContent = ({
  mode,
  search,
  setSearch,
  selectedIds,
  isAtCapacity,
  onToggleAttendee,
}: Props) => {
  const isReplaceMode = mode === "replace";

  return (
    <VStack flex={1} bg="surface-primary">
      <AddPatrons
        search={search}
        setSearch={setSearch}
        currentPatron={undefined}
        isGroupFullOfAttendees={!isReplaceMode && isAtCapacity}
        isGroupFullOfGuests={!isReplaceMode && isAtCapacity}
        isGroupFullOfMembers={!isReplaceMode && isAtCapacity}
        checkNewDisabled={!isReplaceMode && isAtCapacity}
        canAddNewGuest={false}
        showGuestListOverlay={false}
        onAddUnknownGuest={undefined}
        onRemoveUnknownGuest={undefined}
        players={selectedIds}
        allPlayers={selectedIds}
        handleAddMemberClick={onToggleAttendee}
        handleAddGuestClick={onToggleAttendee}
        bg="surface-primary"
        includeTransportationType={false}
        unknownGuestCount={0}
        memberHoldCount={0}
        unknownGuestsEnabled={false}
        memberHoldEnabled={false}
      />
    </VStack>
  );
};
